import { Button, FormControl, Input, Table, Typography } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import UsersDialog from "../Dialogs/UsersDialog";

interface User {
	users_id: string;
	email_address: string;
	full_name: string;
	title: string;
	buildings: string;
	is_packing_lists?: boolean;
}

export default function UsersListing() {
	const [users, setUsers] = React.useState<Array<User>>();
	const [search, setSearch] = React.useState("");
	const [user, setUser] = React.useState("");
	const [dialog, setDialog] = React.useState(false);
	React.useEffect(() => getData(), []);

	const getData = () => {
		setDialog(false);
		fetch("User/GetUserSetup", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((x) => setUsers(x));
	};

	const s = search.toLowerCase();
	const rows = users?.filter((x) => Util.isNullOrEmpty(search) || x.full_name?.toLowerCase().includes(s) || x.email_address?.toLowerCase().includes(s) || x.buildings?.toLowerCase().includes(s));
	return (
		<>
			{dialog && <UsersDialog usersId={user} close={getData} />}
			<div style={{ overflowY: "auto" }}>
				<div>
					<Typography sx={{ display: "inline-block" }} level="title-lg">
						Users Setup
					</Typography>
					<div style={{ float: "right", display: "flex" }}>
						<FormControl sx={{ marginRight: 1 }}>
							<Input
								name="Search"
								placeholder="Global Search"
								onChange={(event) => {
									setSearch(event.target.value);
								}}
								value={search}
							/>
						</FormControl>
						<Button
							onClick={() => {
								setUser("");
								setDialog(true);
							}}>
							New User
						</Button>
					</div>
				</div>
				<Table stripe="even" hoverRow>
					<thead>
						<tr>
							<th>Name</th>
							<th>Email</th>
							<th>Title</th>
							<th>Packing lists</th>
							<th>Buildings</th>
						</tr>
					</thead>
					<tbody>
						{rows?.map((x) => (
							<>
								<tr
									style={{ cursor: "pointer" }}
									onClick={() => {
										setUser(x.users_id);
										setDialog(true);
									}}>
									<td>{x.full_name}</td>
									<td>{x.email_address}</td>
									<td>{x.title}</td>
									<td>{x.is_packing_lists ? "Yes" : ""}</td>
									<td>{x.buildings}</td>
								</tr>
							</>
						))}
					</tbody>
				</Table>
			</div>
		</>
	);
}
